import StrikeZoneModelBase from "../../classificators/strikeZoneModel/StrikeZoneModelBase.js";
import ResultsFormatterBase from "../../formatters/ResultsFormatterBase.js";
import ResultData from "../../enums/ResultData.js";
import ResultType from "../../enums/ResultType.js";
import PitchData from "../../enums/PitchData.js";
import PitchReprocessed from "../../enums/PitchReprocessed.js";
import StringifiedParameterFormatter from "../StringifiedParameterFormatter.js";
import ResultDataNew from "../../enums/ResultDataNew.js";
import IterableDataProcessor from "../../entities/IterableDataProcessor.js";
import DataSection from "../../enums/DataSection.js";
import HitReprocessed from "../../enums/HitReprocessed.js";

class StrikeZoneSectorFormatter extends ResultsFormatterBase{
    constructor(strikeZoneModel, newStructure){
        super();
        
        if (!(strikeZoneModel instanceof StrikeZoneModelBase)){
            throw new TypeError(`strikeZoneModel must inherit from StrikeZoneModelBase`);
        }

        if (typeof(newStructure) !== 'undefined' && typeof(newStructure) !== 'boolean') {
            throw new TypeError('newStructure must be undefined or bool');
        }

        this.strikeZoneModel = strikeZoneModel;
        this.newStructure = !!newStructure;
    }

    format(results) {
        if (this.newStructure) {
            return this.formatForNewStructure(results);
        }

        for (let i = 0; i < results.length; i++){
            let result = results[i];

            if (!result || result[ResultData.Type.key] !== ResultType.Pitch.key){
                continue;
            }

            if (!result.hasOwnProperty(ResultData.Data.key)){
                continue;
            }

            let strikeZoneLocation = result[ResultData.Data.key][PitchData.StrikeZoneFront.key];
            let strikeZoneSector = null;

            if (strikeZoneLocation){
                // try to extract horizontal and vertical location...
                let formatted = StringifiedParameterFormatter(
                    result[ResultData.Data.key][PitchData.StrikeZoneFront.key], ';', PitchData.StrikeZoneFront.stringifiedAs, parseFloat
                );

                if (formatted){
                    const horizontalLocation = formatted.X;
                    const verticalLocation = formatted.Z;

                    // TODO - what if we have obviously bad data like 0 - 0
                    // TODO - what if we have an exception here ? save null or stop ?
                    strikeZoneSector = this.strikeZoneModel.determineSector(horizontalLocation, verticalLocation).key;
                }
            }

            result[ResultData.Data.key][PitchReprocessed.StrikeZonePositionR.key] = strikeZoneSector;
        }

        return results;
    }

    formatForNewStructure(results) {
        const dataProp = ResultDataNew.Data.key;
        for (let i = 0; i < results.length; i++){
            let result = results[i];

            if (!result || !ResultType.hasPitch(result[ResultDataNew.Type.key])) {
                continue;
            }

            if (!result.hasOwnProperty(dataProp) || !result[dataProp]){
                continue;
            }

            let strikeZoneLocation = IterableDataProcessor.getObjectContent(
                result, ResultDataNew.getDataPath(PitchData.StrikeZoneFront.key, DataSection.Sensor.key, ResultType.Pitch.key)
            );
            let strikeZoneSector = null;

            if (strikeZoneLocation){
                // try to extract horizontal and vertical location...
                let formatted = StringifiedParameterFormatter(
                    strikeZoneLocation, ';', PitchData.StrikeZoneFront.stringifiedAs, parseFloat
                );

                if (formatted){
                    const horizontalLocation = formatted.X;
                    const verticalLocation = formatted.Z;

                    // TODO - what if we have obviously bad data like 0 - 0
                    // TODO - what if we have an exception here ? save null or stop ?
                    strikeZoneSector = this.strikeZoneModel.determineSector(horizontalLocation, verticalLocation).key;
                }
            }

            if (ResultType.hasHit(result[ResultDataNew.Type.key])) {
                IterableDataProcessor.setObjectContent(
                    result,
                    ResultDataNew.getDataPath(PitchReprocessed.StrikeZonePositionR.key, DataSection.Tagging.key, ResultType.Pitch.key),
                    strikeZoneSector
                );
            }

            if (ResultType.hasPitch(result[ResultDataNew.Type.key])) {
                IterableDataProcessor.setObjectContent(
                    result,
                    ResultDataNew.getDataPath(HitReprocessed.StrikeZonePositionR.key, DataSection.Tagging.key, ResultType.Hit.key),
                    strikeZoneSector
                );
            }
        }

        return results;
    }
};

export default StrikeZoneSectorFormatter;